var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSearchBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62926 3.50924C6.62926 3.29059 6.71612 3.08089 6.87073 2.92628C7.02534 2.77167 7.23504 2.68481 7.45369 2.68481C7.67234 2.68481 7.88204 2.77167 8.03665 2.92628C8.19126 3.08089 8.27812 3.29059 8.27812 3.50924V4.33367H13.2247V3.50924C13.2247 3.29059 13.3116 3.08089 13.4662 2.92628C13.6208 2.77167 13.8305 2.68481 14.0491 2.68481C14.2678 2.68481 14.4775 2.77167 14.6321 2.92628C14.7867 3.08089 14.8736 3.29059 14.8736 3.50924V4.33367H16.5224C16.9597 4.33367 17.3791 4.50739 17.6883 4.81661C17.9976 5.12583 18.1713 5.54523 18.1713 5.98253V15.8757C18.1713 16.313 17.9976 16.7324 17.6883 17.0416C17.3791 17.3508 16.9597 17.5245 16.5224 17.5245H4.9804C4.5431 17.5245 4.1237 17.3508 3.81448 17.0416C3.50526 16.7324 3.33154 16.313 3.33154 15.8757V5.98253C3.33154 5.54523 3.50526 5.12583 3.81448 4.81661C4.1237 4.50739 4.5431 4.33367 4.9804 4.33367H6.62926V3.50924ZM4.9804 5.98253V7.63139H16.5224V5.98253H4.9804ZM4.9804 9.28025V15.8757H16.5224V9.28025H4.9804Z",
    fill: "#2D333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSearchBar);
export default __webpack_public_path__ + "static/media/calendarSearchBar.3904e44d93bc9eb466225d5cc39bf3ec.svg";
export { ForwardRef as ReactComponent };